import { Container } from "./styles";
import MainTable from "../../components/MainTable";
import { useEffect, useState } from "react";
import { Title } from "../../styles/global";
import useUsuario from "../../actions/cruds/useUsuario";
import { formatCPF, formatarData  } from "../../utils/formatDados";
import { useAuth } from "../../hooks/auth";
import getPermission from "../../utils/getPermission";

import api from "../../services/api";

export function Users() {
  // const { usuarios, getUsers } = useUsuario();
  const [logins, setLogins] = useState([]);
  const [noPaginationLogins, setNoPaginationLogins] = useState([]);
  const [pagesQuant, setPagesQuant] = useState(0);
  const [seachValue, setSearchValue] = useState("");

  // useEffect(() => {
  //   getUsers();
  // }, []);

  const {login} = useAuth();
  const usuariosPermission = getPermission(login,"Usuários") ?? '';

  useEffect(() => {
    api
      .get("logins")
      .then((response) => {
        setLogins(response.data);
        setPagesQuant(response.data.pagination.total_pages);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    if (pagesQuant == 0) return;
    let arr = [];
  
    const promises = [];
  
    for (let page = 1; page <= pagesQuant; page++) {
      const promise = api.get(`logins?page=${page}`).then((response) => {
        arr = arr.concat(response.data.data);
      }).catch((error) => console.log(error));
      promises.push(promise);
    }
  
    Promise.all(promises).then(() => {
      setNoPaginationLogins(arr);
    });
  }, [pagesQuant]);

  const handlePagination = (goBack = false) => {
    const page = goBack ? -1 : 1;

    api
      .get(`logins?page=${logins.pagination.current_page + page}`)
      .then((response) => {
        setLogins(response.data);
      })
      .catch((error) => console.log(error));
  };

  const organizeData = (data: any) => {
    const withoutData = <i>Sem dados</i>;

    if (data && typeof data === "object") {

      if(seachValue != "") {
        data = noPaginationLogins.filter((user) => user.nome.toLowerCase().includes(seachValue.toLowerCase()));
      }

      data = data.map((d: any) => {
        const orgao = d.organization ? d.organization.nome : withoutData;
        const ultimo_acesso = d.ultimo_acesso ? formatarData(d.ultimo_acesso) : withoutData;

        return {
          id: d.id,
          cpf: formatCPF(d.cpf),
          nome: d.nome,
          email: d.email,
          ativo: d.ativo,
          orgao: orgao,
          ultimo_acesso: ultimo_acesso,
        };
      });
    }

    return data;
  };

  const columnData = [
    { headerName: "Código", field: "id" },
    { headerName: "Usuário", field: "cpf" },
    { headerName: "Nome", field: "nome" },
    { headerName: "E-mail", field: "email" },
    { headerName: "Status", field: "ativo" },
  ];

  const onSearchChange = (newValue: any) => {
    setSearchValue(newValue);
  }

  return (
    <>
      <Title color="#333">
        <span>Gestão de Usuários</span>
      </Title>
      <Container color="#FFF">
        <MainTable
          data={organizeData(logins.data)}
          pagination={logins.pagination}
          permission={usuariosPermission}
          hideCreate={usuariosPermission == "Visitante"}
          onSearchChange={onSearchChange}
          handlePagination={handlePagination}
          registerLink="/usuarios/cadastrar"
          columns={columnData}
          dropdown={{
            view: { linkTo: "/usuarios/visualizar" },
            editar: { linkTo: "/usuarios/editar" },
            desativar: { linkTo: "users" },
          }}
        />
      </Container>
    </>
  );
}
